
define('unknown/models/activationModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var Activation = Backbone.Model.extend({
		urlRoot:"/draftapp/activations",
		idAttribute: 'key',
		defaults: {
	    	key: null,
	    	activationType: null,
	    	activated: 0
	    },

	    initialize: function() {
	    	
	    },

	    isActivated: function() {
	    	return this.get("activated") > 0;
	    }	
	});
	
	return Activation;  
});